import React, { useEffect, useMemo, useState } from 'react';
import { useTitle } from '../Hooks';
import { JobWorker } from '../Classes';
import { Stat, Header } from 'react-frontier';
import { Card } from '../components';
import API, { CDN_URL } from '../API';
import moment from 'moment';
import { Link } from 'react-router-dom';

var UserPostings = ()=>{
	var { setTitle } = useTitle();
	var [postings, setPostings] = useState<JobWorker[]>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		setTitle('Mis Empleos')
		API.getUserPostings(true).then(res=>{
			if(res.error) return setLoadError(res.message);
			setPostings(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error inesperado cargando los empleos del usuario. (LCL-1)');
		})
	}, []);

	var posting_count = useMemo(()=>{
		var data = { approved: 0, pending: 0, past: 0 }
		if(!postings) return data;
		for(var i of postings){
			if(!!i.approved && !i.rejected && moment().unix() < i.date_end){
				data.approved += 1;
			}else if(!i.approved && !i.rejected){
				data.pending += 1;
			}else{
				data.past += 1;
			}
		}
		return data;
	}, [postings]);

	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!postings){
		return <Header loading text='Cargando datos' />;
	}

	return <div className='tp user-postings-screen'>
		<Stat.Group>
			<Stat value={posting_count.approved} label={'Empleos'} />
			<Stat value={posting_count.pending} label={'Pendientes'} />
		</Stat.Group>
		<Header text='Activos' subtext={'Empleos activos'} centered={false} style={{ marginTop: 15 }} size='small' />
		{postings.length !== 0 && posting_count.approved > 0 ? (
			postings.filter(p => p.approved && moment().unix() < p.date_end).map(p=>(
				<Card className='posting' key={`LQPLH-${p.posting_id}`} >
					<div className="left">
						<div className="name">{p.job_name}</div>
						<div className="posting-name">{p.posting_name}</div>
						<div className="meta id">Desde: {moment.unix(p.date_start).format('DD/MMM/YY')}</div>
					</div>
					<div className='right'>
						<div className="job-name">{p.business_name}</div>
					</div>
				</Card>
			))
		) : (
			<Card empty>No cuentas con empleos activos</Card>
		)}
		{(postings.length !== 0 && posting_count.pending>0) ? <>
			<Header text='Pendientes' subtext={'Empleos pendientes de ser aprobado'} centered={false} style={{ marginTop: 15 }} size='small' />
			{postings.filter(p => !p.approved && !p.rejected).map(p=>(
				<Card className='posting' key={`LQPLH-${p.posting_id}`} as={Link} to={`/posting/${p.posting_id}`}>
					<div className="left">
						<div className="name">{p.job_name}</div>
						<div className="posting-name">{p.posting_name}</div>
					</div>
					<div className='right'>
						<div className="job-name">{p.business_name}</div>
					</div>
				</Card>
			))}
		</> : null}
		{(postings.length !== 0 && posting_count.past>0) ? <>
			<Header text='Pasados' subtext={'Empleos completados o terminados'} centered={false} style={{ marginTop: 15 }} size='small' />
			{postings.filter(p => p.date_end < moment().unix() && p.approved || p.rejected).map(p=>(
				<Card className='posting' key={`LQPLH-${p.posting_id}`} >
					<div className="left">
						<div className="name">{p.job_name}</div>
						<div className="posting-name">{p.posting_name}</div>
						{!p.rejected ? (
							<div className="meta id">
								Desde: {moment.unix(p.date_approved).format('DD/MMM/YY')}
							</div>
						) : (
							<div className='rejected'>Rechazado</div>
						)}
					</div>
					<div className='right'>
						<div className="job-name">{p.business_name}</div>
					</div>
				</Card>
			))}
		</> : null}
	</div>
}

export default UserPostings;